import {ExtraChargeType} from "../graphql/queries"
import * as React from "react"
import {Form} from "semantic-ui-react"
import {centsToString, parseMoney} from "../model/charges"

interface ExtraChargeTypeInputProps {
  value: ExtraChargeType
  disabled: boolean
  onChange: (type: ExtraChargeType) => void
}

export const ExtraChargeTypes = [
  ExtraChargeType.WAITING_TIME,
  ExtraChargeType.AIRPORT_PARKING_TIME,
  ExtraChargeType.CHANGED_DROPOFF_ADDRESS,
  ExtraChargeType.CHANGED_PICKUP_ADDRESS,
  ExtraChargeType.OTHER,
  ExtraChargeType.INITIAL_LOYALTY_CREDIT,
  ExtraChargeType.REFERRER_LOYALTY_CREDIT,
]

export const ExtraChargeTypeLabels = new Map([
  [ExtraChargeType.AIRPORT_PARKING_TIME, "Airport parking time"],
  [ExtraChargeType.CHANGED_DROPOFF_ADDRESS, "Changed dropoff address"],
  [ExtraChargeType.CHANGED_PICKUP_ADDRESS, "Changed pickup address"],
  [ExtraChargeType.WAITING_TIME, "Waiting time"],
  [ExtraChargeType.OTHER, "Other"],
  [ExtraChargeType.INITIAL_LOYALTY_CREDIT, "Referral loyalty credit"],
  [ExtraChargeType.REFERRER_LOYALTY_CREDIT, "Referrer loyalty credit"],
])

function ExtraChargeTypeInput({value, onChange, disabled}: ExtraChargeTypeInputProps) {
  return (
    <Form.Select
      search={false}
      value={value}
      disabled={disabled}
      selectOnNavigation={false}
      options={ExtraChargeTypes.map((value) => ({value, text: ExtraChargeTypeLabels.get(value)}))}
      onChange={(e, x) => {
        onChange(x.value as ExtraChargeType)
      }}
    />
  )
}

interface ExtraChargeData {
  type: ExtraChargeType
  description: string
  amount: number
}

interface ExtraChargeFormProps {
  disabled: boolean
  data: ExtraChargeData | null
  onSave: (data: ExtraChargeData) => void
  onReset: () => void
}

interface ExtraChargeFormState {
  type: ExtraChargeType
  description: string
  amount: string
}

export class ExtraChargeForm extends React.Component<ExtraChargeFormProps, ExtraChargeFormState> {
  constructor(props: ExtraChargeFormProps) {
    super(props)

    const {data} = props
    if (data) {
      this.state = {
        type: data.type,
        description: data.description,
        amount: centsToString(data.amount),
      }
    } else {
      this.state = {
        type: ExtraChargeType.WAITING_TIME,
        description: "",
        amount: "",
      }
    }
  }

  render() {
    const {type, description, amount} = this.state
    const {disabled, onSave, onReset} = this.props
    const cents = parseMoney(amount)

    return (
      <div>
        <Form.Group>
          <Form.Field>
            <label>Type</label>
            <ExtraChargeTypeInput
              disabled={disabled}
              value={type}
              onChange={(type) => {
                this.setState({type})
              }}
            />
          </Form.Field>
          <Form.Field error={cents === null}>
            <label>Amount</label>
            <Form.Input
              disabled={disabled}
              value={amount}
              onChange={(e, x) => {
                this.setState({amount: x.value})
              }}
              onBlur={() => {
                if (cents !== null) {
                  this.setState({amount: centsToString(cents)})
                }
              }}
            />
          </Form.Field>
        </Form.Group>
        <Form.Field>
          <label>Description</label>
          <Form.TextArea
            disabled={disabled}
            value={description}
            onChange={(e, x) => {
              this.setState({description: String(x.value)})
            }}
          />
        </Form.Field>
        <Form.Group>
          <Form.Button
            disabled={cents === null || disabled}
            onClick={() => {
              if (cents === null || disabled) {
                return
              }
              onSave({type, description, amount: cents})
            }}
            content="Save"
          />
          <Form.Button
            disabled={disabled}
            onClick={() => {
              if (disabled) {
                return
              }
              onReset()
            }}
            content="Reset"
          />
        </Form.Group>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/ExtraChargeForm.tsx